import { NgModule } from '@angular/core';

import { InfiniteScrollDirective } from './infinite-scroll.directive';
import { KeepScrollDirective } from './keep-scroll.directive';
import { ScrollGlueDirective } from './scroll-glue.directive';

const COMPONENTS = [InfiniteScrollDirective, KeepScrollDirective, ScrollGlueDirective];

@NgModule({
  declarations: COMPONENTS,
  exports: COMPONENTS,
})
export class ScrollModule {}
